<template>
  <BTextarea
    v-bind="$attrs"
    :value="ateValue"
    :skeleton="skeleton"
    :disabled="disabled"
    :validate="validate"
    :label="ateLabel"
    data-vv-as="Принадлежность к АТЕ"
    append-icon="mdi-pencil-outline"
    readonly
    always-clearable
    rows="1"
    @click="ateValue ? null : onEdit()"
    @click:clear="onClear"
    @click:append="onEdit"
  />
</template>

<script>
import { createBTextFieldAteModal } from './BTextFieldAte/utils'
import BTextarea from './BTextarea.vue'


export default {
  name: 'BTextFieldAte',
  $_veeValidate: {
    value() {
      return [].concat(
        this.regions,
        this.municipalities,
        this.schools,
      )
    },
    name() {
      return this.name
    },
  },
  components: {
    BTextarea,
  },
  inheritAttrs: false,
  props: {
    skeleton: Boolean,
    disabled: Boolean,
    validate: [String, Object],
    model: String,
    region: {
      type: Object,
    },
    municipality: {
      type: Object,
    },
    school: {
      type: Object,
    },
    parent_mode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ateLabel() {
      return [
        'Принадлежность к АТЕ',
        this.region && '(Регион)',
        this.municipality && '(Муниципальный район)',
        this.school && '(Образовательная организация)',
      ].filter(Boolean).join(' ')
    },
    ateValue() {
      let { region, municipality } = this
      const { school } = this

      if (municipality) {
        region = municipality.region
      }

      if (school) {
        region = school.region
        municipality = school.municipality
      }

      return [
        region,
        municipality,
        school,
      ].filter(Boolean).map((_) => _.name).join(' > ')
    },
  },
  methods: {
    createModal(ctx, props) {
      return createBTextFieldAteModal(ctx, props)
    },
    async onEdit() {
      if (this.modal) return

      const propsData = this.$props
      this.modal = await this.createModal(this, propsData)
      const result = await this.modal.open()
      this.modal = false

      const [region, municipality, school] = result

      if (
        region === this.region
        && municipality === this.municipality
        && school === this.school
      ) { return }

      this.$emit('update:region', region)
      this.$emit('update:municipality', municipality)
      this.$emit('update:school', school)
      this.$emit('change')
    },
    onClear() {
      this.$emit('update:region', null)
      this.$emit('update:municipality', null)
      this.$emit('update:school', null)
      this.$emit('click:clear')
    },
  },
}
</script>
